import React from "react";
import { ReactComponent as Logo } from "../assets/images/svg/Logo.svg";

export default function Layout({ children, title, signup }) {
  return (
    <div className="auth-page-layout">
      <div className="grid m-0 p-0">
        <div
          className={`side-img-div col-12 md:col-6 p-0 m-0 ${
            signup ? "signup-img" : "login-img"
          }`}
        >
          {!signup && (
            <div className="hidden md:block side-img-text">
              Literally it does not mean anything. It is a sequence of words
              without a sense of Latin derivation that make up a text also known
              as filler text, fictitious, blind or placeholder.
            </div>
          )}
        </div>
        <div className="col-12 md:col-6 flex flex-column justify-content-center ">
          <div className="auth-form">
            <div className="logo">
              <Logo />
              <div>IVO</div>
            </div>
            {title && (
              <>
                <div className="form-title">{title}</div>
                <div className="line"></div>
              </>
            )}

            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
